module.exports = "/layout/app/images/bg-box-icon.b2c006bb.svg";